import { d as __extends } from '../tslib.es6-4cb9af8a.js';
import { ErrorCodes } from './errorCodes.js';

var AppError = /** @class */ (function (_super) {
    __extends(AppError, _super);
    function AppError(errorCode, errorName, errorMessage, meta) {
        if (meta === void 0) { meta = {}; }
        var _this = _super.call(this, "".concat(errorName ? errorName + ' - ' : '').concat(errorMessage || '')) || this;
        _this.errCode = null;
        _this.errSource = null;
        _this.code = null;
        _this.source = null;
        _this.meta = null;
        _this.name = errorName;
        _this.message = errorMessage;
        _this.code = errorCode;
        _this.meta = meta || {};
        switch (errorCode) {
            case ErrorCodes.AMS_ERR:
                _this.source = 'AMS';
                break;
            case ErrorCodes.NET_ERR:
                _this.source = 'HTTP';
                break;
            case ErrorCodes.AIS:
                _this.source = 'AIS';
                break;
            case ErrorCodes.CDN_ERR:
                _this.source = 'CDN';
                break;
            case ErrorCodes.PLAYER_ERR:
                _this.source = 'PLAYER';
                break;
            default:
                _this.source = 'JS';
                break;
        }
        _this.errSource = _this.source;
        _this.errCode = _this.code;
        return _this;
    }
    return AppError;
}(Error));

export { AppError };
